import { ILoadDataOptions } from '../../typings/loadDataOptions'
export default ({
  isServer,
  isBoxenUser,
  internalServerUrl = '',
  baseUrl
}: ILoadDataOptions) => {
  let apiUrlPrefix = ''
  // on client side there's no need for prefix, browser will append it for us
  if (isServer) {
    apiUrlPrefix = isBoxenUser ? baseUrl : internalServerUrl
  }
  return apiUrlPrefix
}



// WEBPACK FOOTER //
// ./common/utils/getProxyApiUrl.ts